import { render, staticRenderFns } from "./LdpUserChamSocKhachHang.vue?vue&type=template&id=e64d7776&scoped=true&"
import script from "./LdpUserChamSocKhachHang.vue?vue&type=script&lang=js&"
export * from "./LdpUserChamSocKhachHang.vue?vue&type=script&lang=js&"
import style0 from "./LdpUserChamSocKhachHang.vue?vue&type=style&index=0&id=e64d7776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64d7776",
  null
  
)

export default component.exports